export default __webpack_public_path__ + "static/media/logback.6cd1952f.jpg";